<template>
  <div v-if="filter.visible" class="accordion-panel filter-item" :class="{ 'filterTs': brandName === Brand.Travelsphere}">
    <h2 class="accordion-panel__heading js-accordion-trigger filter-item__title" :class="{ 'accordion-panel__buttonTs': brandName === Brand.Travelsphere }">{{filter.label}}</h2>
    <div class="accordion-panel__content js-accordion-target filter-item__options">
      <ul class="filter-list">
        <li class="filter-list__item" v-for="(item, itemKey) in filter.children" :key="itemKey">
          <label>
            <input
              type="checkbox"
              :checked="item.selected"
              @click="toggleFilterValue(filterKey, itemKey, $event)"
            />
            <span class="filter-list__label">
              {{item.label}}
              <span class="filter-list__count">({{item.count}})</span>
            </span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import fetchItems from '@/vue/mixins/fetchItems';
import {Brand} from '../../brand.js';

export default {
  mixins: [fetchItems],

  props: {
    filter: {
      type: Object,
      required: true
    },
    filterKey: {
      type: Number,
      required: true
    },
    store: {
      type: String,
      required: true
    },
    brandName: String
  },

  data() {
    return {
      Brand
    };
  },

  methods: {
    // toggle a filter on/off
    toggleFilterValue(filterKey, itemKey, e) {
      this.$store.dispatch(`${this.store}/toggleFilterValue`, {
        filterKey: filterKey,
        itemKey: itemKey,
        checked: e.target.checked
      });
      this.fetchItems();
    }
  }
};
</script>